import { post, get } from './httpClient'

export const createNews = (body) => post('/news/createnews', body)
export const isSeenNews = (body) => post('/news/updatehadseennews', body)
export const getAllNew = (params) => get('/news/newsfornoti', params)
export const getNewMySelf = (params) => get('/news/newsbyself', params)
export const deleteNew = (body) => post('/news/delete', body)
export const updateNew = (body) => post('/news/update', body)
